module.exports = __webpack_public_path__ + "img/wdcb@2x.5a043418.png";